import { isNil } from 'lodash';
import { UseListUsersResult, useListUsers } from './useListUsers';

/**
 * Members of a single DM channel via listUsers (memberOfChannelIds).
 *
 * A thin wrapper that pins the DM-specific input: deactivated participants are
 * included so banners/images still render them, ordered by first name.
 *
 * Callers should use `user.isMe` (e.g. `users.find(u => !u.isMe)` for the other
 * participant in a 1:1 DM), and `total` for the member count.
 */
export function useDmChannelUsers(channelId: number | undefined): UseListUsersResult {
  return useListUsers({
    input: {
      memberOfChannelIds: isNil(channelId) ? undefined : [channelId],
      includeDeactivated: true,
      excludeSystemUsers: true,
      orderBys: [{ orderBy: 'firstName', direction: 'ASC' }],
    },
    customCacheKey: isNil(channelId) ? '' : `dm-members-${channelId}`,
    skip: isNil(channelId),
  });
}
